"use client";

import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
} from "../../../components/ui/card";
import { ArrowLeft, ChevronDown } from "lucide-react";
//import Link from "next/link";
import { Separator } from "../../../components/ui/separator";
import { useNavigate } from "react-router-dom";
import Header from "../../../layouts/Header";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const sections = [
    {
      title: "1. Overview",
      content: `
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vehicula, elit a lacinia ultricies, nunc odio posuere metus, id dictum arcu risus eget eros.
        \n\nSubheading:
        \n1. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        \n2. Pellentesque nec orci nec arcu pulvinar tincidunt.
        \n3. Integer eget lectus id turpis fermentum pretium.
      `,
    },
    {
      title: "2. Non-account holders",
      content: `
        Non-account holders are individuals who interact with our services without creating a formal account. Examples include visiting our site, exploring public content, and using guest features.
        \n\nSubheading:
        \n1. Data we collect includes browsing activity and IP address.
        \n2. Temporary data stored includes session activity.
        \n3. Learn more in our Data Use Policy.
      `,
    },
    {
      title: "3. Personal information we collect",
      content: `
        We collect personal information to enhance your experience, including:
        \n\n- Name, email address, and contact details.
        \n- Usage activity, such as pages visited and preferences.
        \n- Payment details for financial transactions.
      `,
    },
    {
      title: "4. How your personal data is used",
      content: `
        Your personal data is used to:
        \n\n- Provide personalized services and features.
        \n- Improve the platform and diagnose issues.
        \n- Comply with legal obligations.
      `,
    },
    {
      title: "5. Your data protection rights",
      content: `
        You have the following rights:
        \n\n1. Access: Request access to your personal data.
        \n2. Rectification: Update any incorrect information.
        \n3. Erasure: Request deletion of your data.
      `,
    },
    {
      title: "6. How we protect your personal data",
      content: `
        Protecting your data is our priority:
        \n\n- We use encryption for sensitive information.
        \n- Regular security audits ensure compliance.
        \n- Access is limited to authorized personnel only.
      `,
    },
  ];

  const [selectedSection, setSelectedSection] = useState(0);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div
          className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white"
          onClick={() => {
            navigate("/settings/about");
          }}
        >
          <ArrowLeft className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20" />
          <p
            className="text-sm font-medium underline mr-2"
            onClick={() => {
              navigate("/settings/index");
            }}
          >
            Settings
          </p>
          <p className="text-sm font-medium"> / About / Privacy Policy</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
          <div className="max-w-5xl w-full">
            <Card className="bg-white rounded-2xl shadow-sm">
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-lg font-semibold text-gray-500">
                  Privacy Policy
                </CardTitle>
                <p className="text-sm text-gray-400 mt-2">
                  Last updated: 13 August 2024
                </p>
              </CardHeader>

              <CardContent className="px-6 pb-6">
                {/* Dropdown Section */}
                <div className="relative mb-6">
                  <button
                    className="w-full px-4 py-3 border border-gray-200 rounded-md flex justify-between items-center text-gray-800 hover:bg-gray-50"
                    onClick={() => setDropdownOpen(!isDropdownOpen)}
                  >
                    <span className="text-sm font-medium">
                      {sections[selectedSection].title}
                    </span>
                    <ChevronDown className="w-4 h-4 text-gray-500" />
                  </button>
                  {isDropdownOpen && (
                    <div className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded-md mt-2 shadow-lg z-10">
                      {sections.map((section, index) => (
                        <button
                          key={index}
                          className={`w-full px-4 py-3 text-left text-sm text-gray-800 hover:bg-gray-50 ${
                            selectedSection === index
                              ? "border-l-4 border-rose-500"
                              : ""
                          }`}
                          onClick={() => {
                            setSelectedSection(index);
                            setDropdownOpen(false);
                          }}
                        >
                          {section.title}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Selected Section Content */}
                <div>
                  <h2 className="text-md font-bold text-gray-800">
                    {sections[selectedSection].title}
                  </h2>
                  <p className="text-sm text-gray-600 whitespace-pre-line">
                    {sections[selectedSection].content}
                  </p>
                </div>

                <Separator className="mt-10" />

                {/* Footer */}
                <div className="flex justify-center mt-8">
                  <p className="text-sm text-gray-500">
                    Questions?{" "}
                    <button
                      className="font-bold text-rose-500 hover:underline cursor-pointer"
                      onClick={() => {
                        navigate("/support/index");
                      }}
                    >
                      Contact us
                    </button>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
